import { invoiceDownloadPDF } from '@/shared/service/b2b';
import { getInvoicePdf } from '@/shared/service/request/alumio';

const analyzePDFBase64 = async (base64: string): Promise<string> =>
  new Promise((resolve, reject) => {
    try {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const invoicePDFUrl = window.URL.createObjectURL(blob);
      resolve(invoicePDFUrl);
    } catch (e) {
      reject(e);
    }
  });


const analyzePDFUrl = (url: string): Promise<string> =>
  new Promise((resolve, reject) => {
    fetch(url)
      .then((res) => res.blob())
      .then((response) => {
        const blob = new Blob([response], { type: 'application/pdf' });

        const invoicePDFUrl = window.URL.createObjectURL(blob);

        resolve(invoicePDFUrl);
      })
      .catch((e) => {
        reject(e);
      });
  });

export const getInvoiceDownloadPDFUrl = async (invoiceId: string, isPayNow = false) => {
  const {
    invoicePdf: { url },
  } = await invoiceDownloadPDF(Number(invoiceId), isPayNow);

  return url;
};

export const handlePrintPDF = async (invoiceId: string, isPayNow = false): Promise<string> => {
  let url = '';
  try {
    url = await getInvoiceDownloadPDFUrl(invoiceId, isPayNow);
    const pdfUrl = await analyzePDFUrl(url);

    return pdfUrl;
  } catch (error) {
    return url;
  }
};

export const handlePrintSapPDF = async (invoiceId: string): Promise<string> => {
  let base64 = '';
  try {
    base64 = await getInvoicePdf(invoiceId);

    const pdfUrl = await analyzePDFBase64(base64);

    return pdfUrl;
  } catch (error) {
    return base64;
  }
};

export default handlePrintPDF;
